import InboxIcon from "@mui/icons-material/MoveToInbox";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SavingsOutlinedIcon from "@mui/icons-material/SavingsOutlined";
import SettingsIcon from "@mui/icons-material/Settings";
import HowToVoteIcon from "@mui/icons-material/HowToVote";
import AssessmentIcon from "@mui/icons-material/Assessment";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import TuneIcon from "@mui/icons-material/Tune";
import SavingsIcon from "@mui/icons-material/Savings";
import ConstructionIcon from "@mui/icons-material/Construction";
import MovingIcon from "@mui/icons-material/Moving";

export interface SubItemMenuConfigModule {
  label: string;
  icon: any;
  path: string;
  permissions: string[] | null;
}

export interface ItemMenuConfigModule {
  label: string;
  icon: any;
  path: string;
  permissions: string[] | null;
  children: SubItemMenuConfigModule | null;
}

export interface MenuConfigModule {
  label: string;
  icon: any;
  path: string;
  permissions: string[] | null;
  children: ItemMenuConfigModule | null;
}

// const isStaging = import.meta.env.VITE_ENV === "staging";
// const development = import.meta.env.VITE_ENV === "development";

export const MENU_CONFIG = [
  {
    label: "Biz Leader",
    icon: <MovingIcon />,
    path: "#",
    children: [
      {
        label: "Dashboard",
        permission: ["view_business_leader_dashboard", "view_trends_dashboard"],
        icon: <InboxIcon />,
        path: "business_leader/dashboard",
      },
      {
        label: "website_projection",
        permission: ["view_website_target"],
        icon: <InboxIcon />,
        path: "business_leader/website_projection",
      },
      {
        label: "trends",
        permission: ["view_trends_dashboard"],
        icon: <InboxIcon />,
        path: "business_leader/trends/",
      },
      {
        label: "forecaster",
        permission: ["view_forecasters_history"],
        icon: <InboxIcon />,
        path: "business_leader/forecaster",
      },
    ],
  },
  {
    label: "performance",
    icon: <AssessmentIcon />,
    path: "#",
    children: [
      {
        label: "page_building",
        permission: ["view_page_content", "view_pages_list"],
        icon: <InboxIcon />,
        path: "performance/page_builder",
      },
      {
        label: "Landing Page Experiences",
        permission: ["view_lp_experience_overview"],
        icon: <InboxIcon />,
        path: "performance/landing_page_experience",
      },
      {
        label: "search_term_operations",
        permission: ["view_st_account_management"],
        icon: <InboxIcon />,
        path: "performance/search_term_operations",
      },
      {
        label: "Performance Insights",
        permission: ["view_paid_traffic_insights"],
        icon: <InboxIcon />,
        path: "performance/insights",
      },
      {
        label: "manual_expenses",
        permission: ["view_manual_expenses"],
        icon: <InboxIcon />,
        path: "performance/manual_expenses",
      },
      {
        label: "competitors_page_speed",
        permission: [
          "view_external_page_speed_performance",
          "view_external_psi_requests",
        ],
        icon: <InboxIcon />,
        path: "performance/competitors_page_speed",
      },
    ],
  },
  {
    label: "organic_traffic",
    icon: <SavingsOutlinedIcon />,
    path: "/comingSoon",
  },
  {
    label: "biz_development",
    icon: <BusinessCenterIcon />,
    path: "#",
    children: [
      {
        label: "dashboard",
        permission: [
          "performance_analysis",
          "view_Bizdev_dashboard",
        ],
        icon: <InboxIcon />,
        path: "biz_development/dashboard",
      },
      {
        label: "Incentivised_traffic",
        permission: [
          "view_incentivezed_traffic_performance",
          "view_monthly_budgets",
        ],
        icon: <InboxIcon />,
        path: "business_development/incentives_traffic",
      },
    ],
  },
  {
    label: "operations",
    icon: <TuneIcon />,
    path: "#",
    children: [
      {
        label: "Brand Data Integrations",
        permission: ["view_brand_configurations"],
        path: "operations/brand_configuration_report",
      },
      {
        label: "Deals & Promotions",
        permission: ["view_commission_plans"],
        path: "operations/deals_and_promotions",
      },
      {
        label: "website_actions",
        permission: ["view_websites_list", "view_websites_groups"],
        icon: <InboxIcon />,
        path: "operations/website_actions",
      },
      {
        label: "page_groups",
        permission: ["view_page_groups"],
        icon: <InboxIcon />,
        path: "operations/page_groups",
      },
      {
        label: "page_speed_performance",
        permission: ["view_page_speed_performance", "view_psi_results"],
        icon: <InboxIcon />,
        path: "operations/page_speed_performance",
      },
      {
        label: "monitoring",
        permission: ["view_monitoring_dashboard"],
        icon: <InboxIcon />,
        path: "operations/monitoring",
      },
      {
        label: "themes",
        permission: ["view_theme"],
        icon: <InboxIcon />,
        path: "operations/theme",
      },
      {
        label: "templates",
        permission: ["view_template"],
        icon: <InboxIcon />,
        path: "operations/templates",
      },
      {
        label: "data_accuracy",
        permission: ["view_data_anomalies"],
        icon: <InboxIcon />,
        path: "operations/data_accuracy",
      },
      {
        label: "advertising_accounts",
        permission: ["view_ads_accounts"],
        icon: <InboxIcon />,
        path: "operations/advertising-accounts",
      },
    ],
  },
  {
    label: "finance",
    icon: <SavingsIcon />,
    path: "#",
    children: [
      {
        label: "receipts",
        permission: ["view_receipts"],
        icon: <InboxIcon />,
        path: "finance/receipts",
      },
    ],
  },
  {
    label: "personal_settings",
    icon: <SettingsIcon />,
    path: "/comingSoon",
  },
  {
    label: "tools",
    icon: <ConstructionIcon />,
    path: "#",
    children: [
      {
        label: "action_items",
        permission: ["view_action_items"],
        icon: <InboxIcon />,
        path: "tools/action_items",
      },
      {
        label: "activity_notes",
        permission: ["view_activity_notes"],
        icon: <InboxIcon />,
        path: "tools/activity_notes",
      },
    ],
  },
  {
    label: "data_collection",
    icon: <HowToVoteIcon />,
    path: "#",
    children: [
      {
        label: "brands_data",
        permission: ["view_brands"],
        path: "data_collection/brand_data",
      },
      {
        label: "Unifier Maps",
        permission: ["view_maps"],
        path: "data_collection/unifier_maps",
      },
      {
        label: "Calculation Types",
        permission: ["view_calculation_types"],
        path: "data_collection/calculation_types",
      },
      {
        label: "Unique Definitions",
        permission: ["view_unique_definitions"],
        path: "data_collection/unique_definitions",
      },
      {
        label: "Data Workflows",
        permission: ["view_monitoring"],
        icon: <InboxIcon />,
        path: "data_collection/data_workflows",
      },
      {
        label: "Data Logs",
        permission: ["view_workflows"],
        icon: <InboxIcon />,
        path: "data_collection/data_logs",
      },
    ],
  },
  {
    label: "admin",
    icon: <AdminPanelSettingsIcon />,
    path: "#",
    children: [
      {
        label: "etl_sequences",
        permission: ["view_etl_sequences"],
        icon: <InboxIcon />,
        path: "admin/etl-sequences",
      },
      {
        label: "etl_list",
        permission: ["view_processes_list"],
        icon: <InboxIcon />,
        path: "admin/etl-process-list",
      },
      {
        label: "etl_logs",
        permission: ["view_processes_logs", "view_process_log"],
        icon: <InboxIcon />,
        path: "admin/etl-process-log",
      },
      {
        label: "meta_entities",
        permission: [
          "view_traffic_click_identifiers",
          "view_territories",
          "view_geos",
          "view_traffic_sources",
          "view_industries",
          "view_device_types",
          "view_products_types",
          "view_currency_symbols",
          "view_organizations",
          "view_format_types",
          "view_collection_methods",
          "view_collection_types",
        ],
        icon: <InboxIcon />,
        path: "admin/meta_entities",
      },
      {
        label: "queries",
        icon: <InboxIcon />,
        path: "admin/queries",
        permission: ["view_datastore_requests"],
      },
    ],
  },
];
